import React from "react";
import MenuList from "./Menu-List";
import "./sidebar.css";
import PropTypes from "prop-types";
class SideBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      crutCities : ["berhampur","bhubaneswar","rourkela","sambalpur"]
    }
  }


  isPathContainCrut = () => {
    return window.location.origin.includes("crut");
  }

  render() {
    return (
      <div
        id="wrapper"
        className="content"
        onMouseOver={this.props.SideBarShow}
        onFocus={this.props.SideBarShow}
        onMouseLeave={this.props.SideBarDontShow}
      >

        <div className="logo">
          <button className="small-nav-handle transparent-btn me-3" onClick={this.props.toggle} onKeyDown={() => {}}>
            <div className="icon-container">
              <span className="sidebar-icon menu-icon" />
            </div>
          </button>
          {!this.isPathContainCrut() && <span className="logo-icon"></span>}
          {this.isPathContainCrut() && <span className="crut-logo-icon"></span>}
        </div>
        <MenuList
          toggleShow={this.props.toggleShow}
          SideBarDontShow={this.props.SideBarDontShow}
          toggle={this.props.toggle}
          location={this.props.location}
        />
      </div>
    );
  }
}

export default SideBar;

SideBar.propTypes = {
  SideBarShow: PropTypes.func,
  SideBarDontShow: PropTypes.func,
  toggle: PropTypes.func,
  toggleShow: PropTypes.any,
  location: PropTypes.any,
};